import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { FiscalYearMinister } from './fiscalYearMinister.model';

const axios = useAxios();

export interface FiscalYearMinisterService {
  Fetch: (fiscalYearId: number) => Promise<AxiosResponse<FiscalYearMinister[]>>;
}

const Fetch = (fiscalYearId: number): Promise<AxiosResponse<FiscalYearMinister[]>> =>
  axios.Get<FiscalYearMinister[]>(`/api/fiscalyears/${fiscalYearId}/ministers`);

export default { Fetch } as FiscalYearMinisterService;
